<div class="container">
  <div class="page-header">
    <h1>Projects</h1>
    <p class="subtitle">Organize your work with project-level governance</p>
  </div>

  <div *ngIf="loading" class="loading">
    <p>Loading projects...</p>
  </div>

  <div *ngIf="error" class="error-box">
    <p>{{ error }}</p>
  </div>

  <div *ngIf="!loading && !error">
    <!-- Projects List -->
    <div class="card">
      <div class="card-header">
        <h2>Projects</h2>
        <button class="btn btn-primary" (click)="showCreateForm = true">Create Project</button>
      </div>

      <div *ngIf="projects.length === 0" class="empty-state">
        <h3>No projects yet</h3>
        <p>Create a project to organize your work and apply project-level policies and budgets.</p>
        <button class="btn btn-primary" (click)="showCreateForm = true">Create First Project</button>
      </div>

      <div *ngIf="projects.length > 0" class="projects-grid">
        <div *ngFor="let project of projects" class="project-card">
          <div class="project-header">
            <h3>{{ project.name }}</h3>
            <span class="project-id"><code>{{ project.id.substring(0, 8) }}...</code></span>
          </div>
          <div class="project-meta">
            <div class="meta-item" *ngIf="project.environments && project.environments.length > 0">
              <strong>Environments:</strong>
              <span *ngFor="let env of project.environments" class="badge badge-env">{{ env }}</span>
            </div>
            <div class="meta-item" *ngIf="project.budget">
              <strong>Budget:</strong>
              <span *ngIf="project.budget.daily">Daily: ${{ project.budget.daily }}</span>
              <span *ngIf="project.budget.monthly">Monthly: ${{ project.budget.monthly }}</span>
            </div>
            <div class="meta-item">
              <strong>Created:</strong> {{ project.created_at ? (project.created_at | date:'short') : 'N/A' }}
            </div>
          </div>
          <div class="project-actions">
            <a [routerLink]="['/projects', project.id]" class="btn btn-sm btn-secondary">SDK usage</a>
            <a [routerLink]="['/runs']" [queryParams]="{project_id: project.id}" class="btn btn-sm btn-secondary">Studio runs</a>
          </div>
        </div>
      </div>
    </div>

    <!-- Create Project Form -->
    <div class="card" *ngIf="showCreateForm">
      <div class="card-header">
        <h2>Create New Project</h2>
      </div>
      <div class="form">
        <div class="form-group">
          <label>Project Name</label>
          <input type="text" [(ngModel)]="newProjectName" class="form-input" placeholder="My Project">
        </div>
        <div class="form-group">
          <label>Environment</label>
          <select [(ngModel)]="newProjectEnv" class="form-select">
            <option value="dev">Development</option>
            <option value="staging">Staging</option>
            <option value="prod">Production</option>
          </select>
        </div>
        <div class="form-actions">
          <button class="btn btn-primary">Create</button>
          <button class="btn btn-secondary" (click)="showCreateForm = false">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</div>
